import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><blockquote parentName="section">
        <h2 parentName="blockquote" {...{
          "id": "this-is-a-header"
        }}>{`This is a header.`}</h2>
        <ol parentName="blockquote">
          <li parentName="ol">{`This is the first list item.`}</li>
          <li parentName="ol">{`This is the second list item.`}</li>
        </ol>
        <p parentName="blockquote">{`Here's some example code:`}</p>
        <pre parentName="blockquote"><code parentName="pre" {...{}}>{`return shell_exec("echo $input | $markdown_script");
`}</code></pre>
      </blockquote>
      <p parentName="section">{`Use 3 dashes for an em-dash. Use 2 dashes for ranges (ex., "it's all
in chapters 12--14"). Three dots ... are converted to an ellipsis.
Unicode is supported. ☺`}</p>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      